var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.q))]),_c('div',{style:({
      width: '350px',
      maxWidth: '100%'
    })},_vm._l((_vm.a),function(item){return _c('p',{key:item.answer,staticClass:"option",class:_vm.selectedValues.find(function (v) { return v === item; }) ? 'item-selected' : 'item',on:{"click":function($event){return _vm.handleClick(item)}}},[_vm._v(" "+_vm._s(item.answer)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }